module.exports = __webpack_public_path__ + "img/no-integration-to-add.6c3b0c28.png";